import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

import { ISingleContentBlockCardItem, ISingleContentBlockImage } from '@typings'

import { AcTitle } from '../ac-title/ac-title'
import { AcTypography } from '../ac-typography/ac-typography'
import { AcImage } from '../ac-image/ac-image'

import styles from './ac-card.module.scss'

export const AcCard = observer(
  ({ title, content, sort, image }: ISingleContentBlockCardItem) => {
    const [searchParams] = useSearchParams()
    const highlightTerm = searchParams.get('highlight') || ''

    const highlightedTitle = useMemo(() => {
      if (!highlightTerm || !title) return title

      const parts = title.split(new RegExp(`(${highlightTerm})`, 'gi'))
      return (
        <>
          {parts.map((part, i) =>
            part.toLowerCase() === highlightTerm.toLowerCase() ? (
              <mark
                key={i}
                style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
                {part}
              </mark>
            ) : (
              part
            ),
          )}
        </>
      )
    }, [title, highlightTerm])

    const highlightedContent = useMemo(() => {
      if (!highlightTerm || !content) return content

      const parts = content.split(new RegExp(`(${highlightTerm})`, 'gi'))
      return (
        <>
          {parts.map((part, i) =>
            part.toLowerCase() === highlightTerm.toLowerCase() ? (
              <mark
                key={i}
                style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
                {part}
              </mark>
            ) : (
              part
            ),
          )}
        </>
      )
    }, [content, highlightTerm])

    return (
      <Box
        className={styles['ac-card']}
        p={2}>
        <AcImage {...(image as ISingleContentBlockImage)} />
        <Box>
          <AcTitle
            level={3}
            color="primary">
            {highlightedTitle}
          </AcTitle>
          <AcTypography>{highlightedContent}</AcTypography>
        </Box>
      </Box>
    )
  },
)
